import type { Booking } from "@kuroo/contracts";
import { KurooApiError } from "@kuroo/sdk";

export function isUnauthenticated(error: unknown): boolean {
  return error instanceof KurooApiError && error.code === "UNAUTHENTICATED";
}

export function formatMoney(cents: number, currency = "ARS"): string {
  return new Intl.NumberFormat("es-AR", { style: "currency", currency }).format(cents / 100);
}

export function dataError(reason: unknown): string {
  return reason instanceof Error ? reason.message : "La API no está disponible.";
}

export function formatDate(value: string, timezone = "America/Argentina/Buenos_Aires"): string {
  return new Intl.DateTimeFormat("es-AR", { dateStyle: "medium", timeStyle: "short", timeZone: timezone }).format(new Date(value));
}

export function bookingCustomerLabel(booking: Booking): string {
  const fullName = [booking.customerFirstName, booking.customerLastName].filter((value): value is string => Boolean(value?.trim())).join(" ").trim();
  return fullName || booking.customerEmail || (booking.customerId ? booking.customerId.slice(0, 8) : "Cliente público");
}
